import './searchForm.scss';

import SearchFormModel from '@/js/common/Domain/Model/SearchForm';
import SearchFormFieldModel from '@/js/common/Domain/Model/SearchFormField';
import DepartureCitiesRepository from '@/js/common/Domain/Repository/DepartureCities';
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import DepartureCityView from '@/js/desktop/View/DepartureCity';
import CheckInDateRangeView from '@/js/desktop/View/CheckInDateRange';
import NightRangeView from '@/js/desktop/View/NightRange';
import TouristGroupDesktop
    from '@/js/desktop/components/searchFormAutocomplete/searchForm/touristGroup/TouristGroupDesktop';
import HotelCategoriesRepository from '@/js/common/Domain/Repository/HotelCategories';
import ResortsRepository from '@/js/common/Domain/Repository/Resorts';
import HotelsRepository from '@/js/common/Domain/Repository/Hotels';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import OperatorsRepository from '@/js/common/Domain/Repository/Operators';

const SearchFormHotelView = Backbone.View.extend({
    dataLayerAnalytics: new DataLayerAnalytics(),
    isValid() {
        return true;
    },
    initialize(options = {}) {
        this.model = new SearchFormModel({
            departureCity: new SearchFormFieldModel({
                collection: DepartureCitiesRepository.repository,
            }),
            countries: new SearchFormFieldModel({
                collection: new CountriesRepository(),
                model: new CountriesRepository(),
            }),
            resorts: new SearchFormFieldModel({
                collection: new ResortsRepository(),
                model: new ResortsRepository(),
            }),
            hotels: new SearchFormFieldModel({
                model: new HotelsRepository(),
            }),
            operators: new SearchFormFieldModel({
                model: new OperatorsRepository(),
            }),
            checkInDateRange: new SearchFormFieldModel({
                model: false,
            }),
            nightRange: new SearchFormFieldModel({
                model: false,
            }),
            touristGroup: new SearchFormFieldModel({
                model: false,
            }),
            hotelCategories: new SearchFormFieldModel({
                model: new HotelCategoriesRepository(HotelCategoriesRepository.repository.getById(window.appConfig.hotelInfo.category)),
            }),
            meals: new SearchFormFieldModel({
                model: false,
            }),
            priceRange: new SearchFormFieldModel({
                model: false,
            }),
            directFlight: new SearchFormFieldModel({
                model: false,
            }),
            block: new SearchFormFieldModel({
                model: false,
            }),
            bonusMiles: new SearchFormFieldModel({
                model: false,
            }),
            mirCashback: new SearchFormFieldModel({
                model: false,
            }),
            warranted: new SearchFormFieldModel({
                model: false,
            }),
            isExclusive: new SearchFormFieldModel({
                model: false,
            }),
            productType: new SearchFormFieldModel({
                model: 'all',
            }),
        });

        this.model.get('departureCity').set('view', new DepartureCityView({
            model: this.model.get('departureCity'),
            el: '.hotel-page-header-form #mainSearchForm .from_city',
            openCallback: () => {
                this.dataLayerAnalytics.generateEvent('changeCity', '');
            },
        }));
        this.model.get('checkInDateRange').set('view', new CheckInDateRangeView({
            model: this.model.get('checkInDateRange'),
            departureCityData: this.model.get('departureCity'),
            checkInDateRange: this.model.get('checkInDateRange'),
            el: '.hotel-page-header-form #mainSearchForm .tour-duration',
            nightRangeEl: '.hotel-page-header-form #mainSearchForm .nights',
            dataLayerAnalytics: this.dataLayerAnalytics,
        }));

        this.model.get('nightRange').set('view', new NightRangeView({
            model: this.model.get('nightRange'),
            departureCityData: this.model.get('departureCity'),
            checkInDateRange: this.model.get('checkInDateRange'),
            daysPlusMin: false,
            el: '.hotel-page-header-form #mainSearchForm .formDropdown.nights',
            dataLayerAnalytics: this.dataLayerAnalytics,
        }));

        this.model.get('touristGroup').set('view', new TouristGroupDesktop({
            model: this.model.get('touristGroup'),
            el: '.hotel-page-header-form .touristGroup',
            dataLayerAnalytics: this.dataLayerAnalytics,
            variants: options?.touristsGroupVariants,
        }));
    },
});

export default SearchFormHotelView;
